// src/components/Dashboard/Dashboard.js

import React, { useState, useEffect } from "react";
import { supabase } from "../../supabase";

export default function Dashboard() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    const { data: profile } = await supabase
      .from("user_profiles")
      .select("full_name, skill_active, service_type")
      .eq("user_id", user.id)
      .single();

    setUserData({ ...profile, userId: user.id });
    setLoading(false);
  };

  const handleViewProfile = () => {
    window.location.href = `/profile/${userData.userId}`;
  };

  const handleBrowseServices = () => {
    window.location.href = "/explore";
  };

  const handleBookings = () => {
    window.location.href = "/bookings";
  };

  const handleMessages = () => {
    window.location.href = "/messages";
  };

  const handleSaved = () => {
    window.location.href = "/saved";
  };

  const handleSettings = () => {
    window.location.href = "/settings";
  };

  const handleEditProfile = () => {
    window.location.href = "/onboarding-mvp";
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    window.location.href = "/";
  };

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fafafa",
        }}
      >
        <p style={{ fontSize: "15px", color: "#525252" }}>Loading...</p>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fafafa",
        padding: "2rem",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: "480px",
          width: "100%",
          backgroundColor: "#fff",
          border: "1px solid #e5e5e5",
          borderRadius: "12px",
          padding: "3rem 2.5rem",
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "500",
              color: "#1a1a1a",
              marginBottom: "0.5rem",
            }}
          >
            Welcome back, {userData.full_name}
          </h1>
          <p
            style={{
              fontSize: "15px",
              color: "#737373",
            }}
          >
            Your {userData.service_type} profile is{" "}
            {userData.skill_active ? "active" : "inactive"}
          </p>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <button
            onClick={handleViewProfile}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#fff",
              backgroundColor: "#000",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "opacity 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
          >
            View My Profile
          </button>

          <button
            onClick={handleBrowseServices}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#525252",
              backgroundColor: "#fff",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#a3a3a3";
              e.currentTarget.style.backgroundColor = "#fafafa";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.backgroundColor = "#fff";
            }}
          >
            Browse Services (Preview)
          </button>

          <button
            onClick={handleBookings}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#525252",
              backgroundColor: "#fff",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#a3a3a3";
              e.currentTarget.style.backgroundColor = "#fafafa";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.backgroundColor = "#fff";
            }}
          >
            Bookings
          </button>

          <button
            onClick={handleMessages}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#525252",
              backgroundColor: "#fff",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#a3a3a3";
              e.currentTarget.style.backgroundColor = "#fafafa";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.backgroundColor = "#fff";
            }}
          >
            Messages
          </button>

          <button
            onClick={handleSaved}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#525252",
              backgroundColor: "#fff",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#a3a3a3";
              e.currentTarget.style.backgroundColor = "#fafafa";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.backgroundColor = "#fff";
            }}
          >
            Saved Profiles
          </button>

          <button
            onClick={handleSettings}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#525252",
              backgroundColor: "#fff",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#a3a3a3";
              e.currentTarget.style.backgroundColor = "#fafafa";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.backgroundColor = "#fff";
            }}
          >
            Settings
          </button>

          <button
            onClick={handleEditProfile}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#525252",
              backgroundColor: "#fff",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#a3a3a3";
              e.currentTarget.style.backgroundColor = "#fafafa";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.backgroundColor = "#fff";
            }}
          >
            Edit Profile
          </button>

          <button
            onClick={handleSignOut}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#737373",
              backgroundColor: "transparent",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              marginTop: "1rem",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#a3a3a3";
              e.currentTarget.style.color = "#525252";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.color = "#737373";
            }}
          >
            Sign Out
          </button>
        </div>

        {/* Coming Soon Notice */}
        <div
          style={{
            marginTop: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#fafafa",
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "13px",
              color: "#737373",
              margin: 0,
            }}
          >
            📊 Analytics and insights coming soon
          </p>
        </div>
      </div>
    </div>
  );
}
